import { ReduxCallTypesConst } from "../../../constants/ReduxCallTypesConst";
import { postAgent21 } from "./CashierSettingCRUD";
import { cashierSettingSlice } from "./CashierSettingSlice";

const { actions } = cashierSettingSlice;

export const fetchCashierSettingUI = (queryParams) => (dispatch) => {
  dispatch(actions.startCall({ callType: ReduxCallTypesConst.ACTION }));

  return postAgent21(queryParams)
    .then((response) => {
      if (response) {
        if (!response.data.isAbort) {
          dispatch(actions.cashierSettingUIFetched({ data: response.data }));
          return response;
        }
      } else {
        throw new Error("Error api: fetchCashierSettingUI");
      }
    })
    .catch((error) => {
      dispatch(
        actions.catchError({ error, callType: ReduxCallTypesConst.ACTION })
      );
      throw error;
    });
};

export const fetchCashierAgentLookup = (queryParams) => (dispatch) => {
  dispatch(actions.startCall({ callType: ReduxCallTypesConst.ACTION }));

  return postAgent21(queryParams)
    .then((response) => {
      if (response) {
        if (!response.data.isAbort) {
          dispatch(actions.cashierAgentLookupFetched({ data: response.data }));
          return response;
        }
      } else {
        throw new Error("Error api: fetchCashierAgentLookup");
      }
    })
    .catch((error) => {
      dispatch(
        actions.catchError({ error, callType: ReduxCallTypesConst.ACTION })
      );
      throw error;
    });
};

export const addCashierAgent = (queryParams) => (dispatch) => {
  dispatch(actions.startCall({ callType: ReduxCallTypesConst.ACTION }));

  return postAgent21(queryParams, true)
    .then((response) => {
      if (response) {
        if (!response.data.isAbort) {
          dispatch(actions.cashierSettingManaged());
          return response;
        }
      } else {
        throw new Error("Error api: addCashierAgent");
      }
    })
    .catch((error) => {
      dispatch(
        actions.catchError({ error, callType: ReduxCallTypesConst.ACTION })
      );
      throw error;
    });
};

export const removeCashierAgent = (queryParams) => (dispatch) => {
  dispatch(actions.startCall({ callType: ReduxCallTypesConst.ACTION }));

  return postAgent21(queryParams, true)
    .then((response) => {
      if (response) {
        if (!response.data.isAbort) {
          dispatch(actions.cashierSettingManaged());
          return response;
        }
      } else {
        throw new Error("Error api: removeCashierAgent");
      }
    })
    .catch((error) => {
      dispatch(
        actions.catchError({ error, callType: ReduxCallTypesConst.ACTION })
      );
      throw error;
    });
};
